/* src/app/shared/components/modals/collapsable-title-modal/collapsable-title-modal.component.scss */
.section-icon {
  font-size: 1.3rem;
  color: var(--ion-color-secondary-contrast);
}
.inputfile {
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 999;
  cursor: pointer;
}
ion-content {
  max-height: calc(100% - 56px) !important;
  height: 744px !important;
}
.embed-config-item {
  border: 1px solid var(--ion-color-medium);
  border-radius: 12px;
  margin-bottom: 16px;
  overflow: hidden;
  background: var(--ion-color-step-50, rgba(0, 0, 0, 0.02));
}
.embed-config-item .embed-config-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 8px 14px;
  background: var(--ion-color-tertiary);
  border-radius: 12px 12px 0 0;
}
.embed-config-item .embed-config-header .embed-config-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--ion-color-tertiary-contrast);
  letter-spacing: 0.6px;
}
.embed-config-item .embed-config-header .embed-config-badge ion-icon {
  font-size: 1rem;
  color: var(--ion-color-tertiary-contrast);
}
.embed-config-item .embed-config-fields {
  padding: 4px 0;
}
.embed-config-item .embed-config-fields .field-icon {
  font-size: 1rem;
  color: var(--ion-color-medium);
  margin-top: 18px;
}
.embed-config-item .embed-option-section {
  padding: 10px 14px 14px;
  border-top: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.08));
  margin-top: 4px;
}
.embed-config-item .embed-option-section .embed-option-label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  opacity: 0.55;
  margin: 0 0 4px 0;
}
.embed-config-item .embed-option-section .embed-radio-group {
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.embed-config-item .embed-option-section .embed-radio-group .radio-option {
  flex: 1;
  border-color: var(--ion-color-secondary);
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s, background 0.15s;
}
.embed-config-item .embed-option-section .embed-radio-group .radio-option ion-item {
  --padding-start: 10px;
  --inner-padding-end: 10px;
  --min-height: 44px;
  --background: transparent;
}
.embed-config-item .embed-option-section .embed-radio-group .radio-option ion-radio {
  color: var(--ion-color-secondary) !important;
  --color-checked: var(--ion-color-medium);
}
.embed-config-item .embed-option-section .embed-radio-group .radio-option .radio-icon {
  font-size: 1.1rem;
  color: var(--ion-color-medium);
}
.embed-config-item .embed-option-section .embed-radio-group .radio-option.embed-radio-selected {
  border: 2px solid var(--ion-color-medium);
  background: rgba(var(--ion-color-medium-rgb), 0.1);
}
.embed-config-item .embed-option-section .embed-radio-group .radio-option.embed-radio-selected .radio-icon {
  color: var(--ion-color-medium);
}
.embed-config-item .embed-image-section {
  padding: 10px 14px 14px;
  border-top: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.08));
}
.embed-config-item .embed-image-section .embed-image-preview {
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 10px;
  max-height: 140px;
}
.embed-config-item .embed-image-section .embed-image-preview ion-img::part(image) {
  max-height: 140px;
}
.embed-config-item .embed-image-section .embed-upload-btn {
  position: relative;
  --background: var(--ion-color-adminDetailsViewActive, var(--ion-color-medium));
  max-width: 60%;
  margin-left: 20%;
}
.embed-config-item .embed-image-section .embed-upload-btn .inputfile {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  cursor: pointer;
}
.embed-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0 8px;
  opacity: 0.45;
}
.embed-empty-state .embed-empty-icon {
  font-size: 2rem;
  margin-bottom: 6px;
}
.embed-empty-state p {
  font-size: 0.85rem;
  margin: 0;
}
@media only screen and (max-width: 720px) {
  ion-header,
  ion-content {
    zoom: 0.8;
  }
  .action-buttons-container {
    zoom: 0.8;
  }
}
/*# sourceMappingURL=collapsable-title-modal.component-EEZDTTN4.css.map */
